import { getProjectColorClass } from "@/components/calendar/CalendarProjectCell";
import type {
  VehicleBooking,
  VehicleBookingCategory,
} from "@/hooks/useVehicles";

/** Colors of appointments without project, by category */
export const bookingCategoryClasses: Record<
  Exclude<VehicleBookingCategory, "project">,
  string
> = {
  service: "bg-amber-500",
  tyre_change: "bg-sky-600",
  inspection: "bg-violet-600",
  cleaning: "bg-emerald-600",
  other: "bg-slate-500",
};

/** Project bookings use their project's calendar color. */
export function getBookingColorClass(booking: VehicleBooking) {
  if (booking.category === "project") {
    return getProjectColorClass({
      status: booking.project?.status ?? null,
      types: booking.project?.types ?? null,
    });
  }
  return bookingCategoryClasses[booking.category];
}
